import { Box } from "@chakra-ui/react";

import DatePicker from "@/components/DatePicker";
import SelectFilter from "@/components/SelectFilter";
import { Dispatch, SetStateAction } from "react";
import { FiltersType } from "../types/filters.type";

type Props = {
  queryFilters: FiltersType;
  setQueryFilters: Dispatch<SetStateAction<FiltersType>>;
};

const Filters = ({ queryFilters, setQueryFilters }: Props): JSX.Element => {
  const handleSearchByStatus = (option: string | undefined) => {
    setQueryFilters((prev) => ({ ...prev, status: option }));
  };

  const handleSearchByDate = (d: string | undefined) => {
    const paymentDate = d ?? undefined;
    setQueryFilters((prev) => ({ ...prev, paymentDate }));
  };

  const handleSearchByType = (option: string | undefined) => {
    setQueryFilters((prev) => ({ ...prev, type: option }));
  };

  return (
    <Box display={"flex"} gap={"1rem"}>
      <DatePicker
        value={queryFilters.paymentDate}
        placeholder="Fecha de Abono"
        setValue={(d) => handleSearchByDate(d)}
      />
      <SelectFilter
        options={["Procesando", "Pagado"]}
        selectedOption={queryFilters.status}
        onSelect={handleSearchByStatus}
        placeholder="Estado"
      />
      <SelectFilter
        options={["Descontada", "Mes Vencido"]}
        selectedOption={queryFilters.type}
        onSelect={handleSearchByType}
        placeholder="Tipo"
      />
    </Box>
  );
};

export default Filters;
